/**
 * Generate a 64-bit decimal string trace ID compatible with Datadog's format:
 * (BigInt(high) << 32n | BigInt(low)).toString()
 */
function generate64BitDecimalId(): string {
    const buf = new Uint32Array(2);
    crypto.getRandomValues(buf);
    return ((BigInt(buf[0]) << 32n) | BigInt(buf[1])).toString();
}

export function generateTraceId(): string {
    return generate64BitDecimalId();
}

export function generateSpanId(): string {
    return generate64BitDecimalId();
}
